import { Plus } from "lucide-react";
import { columns } from "./columns";
import { useNavigate } from "react-router-dom";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { Action } from "@/src/data/types";
import { Button } from "../../ui/button";
import { DataTable } from "../../ui/data-table";

interface ActionProps {
  data: Action[];
}

export const ActionData: React.FC<ActionProps> = ({ data }) => {
  const router = useNavigate();

  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Initiatives (${data.length})`}
          description="Gestion des initiatives "
        />
        <Button
          className="text-xs md:text-sm"
          onClick={() => router(`/admin-dashboard/initiative/ajouter`)}
        >
          <Plus className="w-4 h-4 mr-2" /> Ajouter
        </Button>
      </div>
      <Separator />
      <DataTable searchKey="title" columns={columns} data={data} />
    </>
  );
};
